<template>
    <div class="card col-md-12 mx-auto">
        <div class="card-header card-header bg-primary text-white h4 m-0">
            <page-title :title="($t(titleKey))"></page-title>
        </div>


        <div class="card-body" v-if="hasItems" v-cloak>
            <div v-cloak>
                <div class="input-group col-sm-3 float-right">
                    <div class="input-group-addon fa fa-search" style="display:table-cell"></div>
                    <input class="form-control fa fa-search" name="query" v-model="searchQuery">
                </div>
            </div>
            <custom-grid :data="notifications"
                         :columns="gridColumns"
                         :filter-key="searchQuery"
                         :captions="gridCaptions"
                         :btns="btns">
            </custom-grid>
        </div>
        <div class="card-body" v-else v-cloak>
            <div class="alert alert-warning" role="alert">
                <h4>
                    Липсват данни.
                </h4>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomGrid from "../../../components/grid/CustomGrid";
    import PageTitle from '../../../components/common/PageTitle';

    export default {
        components: {
            CustomGrid,
            PageTitle
        },
        props: {

        },
        data() {
            return {
                componentName: "NotificationsList",
                titleKey: 'sideMenu.notifications', // Трабва на конпонентата за бутоните за дашборд настройките
                loading: false,
                gridCaptions: {
                    id: 'Id',
                    notificationType: this.$t('notificationConfig.type'),
                    messageSubject: this.$t('notificationConfig.subject'),
                },
                gridColumns: ['notificationType', 'messageSubject'],
                notifications: [{
                    id: '',
                    notificationType: '',
                    messageSubject: ''
                }],
                searchQuery: ''
            };
        },
        methods: {
            loadData: function () {
                this.loading = true;

                return this.$http.get('/api/notificationConfig/list'
                ).then((response) => {
                    this.notifications = response.data.notificationConfigs;

                    this.loading = false;
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                        text: this.$helpers.errorText(error),
                        color: 'danger',
                        time: this.$store.getters.notificationDuration
                    })

                    this.loading = false;
                })
            },
            editBtnClick: function (args) {
                if (!this.hasEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                console.log(args);
                this.$router.push(`/administration/notifications/edit/${args.id}`);
            },
            goToDetails(args) {
                if (!this.hasReadRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$router.push(`/administration/notifications/details/${args.id}`);
            },
        },
        mounted: function () {
            this.loadData();

            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });
        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            hasItems() {
                return Array.isArray(this.notifications) && this.notifications.length;
            },
            hasReadRights() {
                return this.$store.getters.claims.notifications.read;
            },
            hasEditRights() {
                return this.$store.getters.claims.notifications.create
                    || this.$store.getters.claims.notifications.update;
            },
            btns() {
                return [{
                    name: "edit",
                    text: "",
                    tooltip: this.$t('buttons.edit.btnText'),
                    class: 'btn btn-primary',
                    icon: "fas fa-edit",
                    show: this.hasEditRights,
                    clickHandler: this.editBtnClick
                }, {
                    name: "details",
                    text: "",
                    tooltip: this.$t('buttons.details.tooltipText'),
                    class: 'btn btn-info',
                    icon: "fas fa-eye",
                    show: this.hasReadRights,
                    clickHandler: this.goToDetails
                }]
            },
        }
    }
</script>

<style scoped>
</style>
